import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-furniture-fabrics-menu',
  templateUrl: './furniture-fabrics-menu.component.html',
  styleUrls: ['./furniture-fabrics-menu.component.css']
})
export class FurnitureFabricsMenuComponent implements OnInit {
    furnitureFabricsId;

    public menu?: Menu;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.furnitureFabricsId = this.stateService.getStateParams()['furniturefabrics_id'];
    }

    private async loadMenu() {
        if (!!this.furnitureFabricsId) {
            this.menu = (await this.datatask.Post(2116, { furniturefabrics_id: this.furnitureFabricsId }))[0];
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    furniturefabrics_id: string;
    furniturefabrics_name: string;
    nbr_of_furniturefabricscolor: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('furnitureFabricsMenu', {
//        templateUrl: 'views/components/views/furnitureFabricsMenu/furnitureFabricsMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'furnitureFabricsMenuService', function ($stateParams, furnitureFabricsMenuService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let furnitureFabricsId = $stateParams.furniturefabrics_id;

//            vm.model = {
//                menu: {}
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await furnitureFabricsMenuService.getMenu({ furniturefabrics_id: furnitureFabricsId }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
